// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__20dm7","header":"ReportDetails_header__3la2K","title":"ReportDetails_title__2kh1u","left":"ReportDetails_left__3KhBN"};